var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div>\n  <div ng-class=\"{ border: delivery.parcelNumber || delivery.orderLineId || delivery.showStatus() }\" class=\"status\"><span class=\"{{ delivery.status }} delivery-status\"></span><span>{{ t('delStatus' + delivery.deliveryStatus) }}</span></div>\n  <div ng-if=\"delivery.showStatus()\" class=\"cell\"><span class=\"label\">{{ t('fleetDelAcknowledged') }}</span><span>{{ delivery.showStatus() ? (delivery.statusTimestamp | moment: 'LT') : '&nbsp;' }}</span></div>\n  <div ng-if=\"delivery.parcelNumber\" class=\"cell\"><span class=\"label\">{{ t('fleetDelParcelNumber') }}</span><span>{{ delivery.parcelNumber || '&nbsp;' }}</span></div>\n  <div ng-if=\"delivery.orderLineId\" class=\"cell\"><span class=\"label\">{{ t('fleetDelOrderLine') }}</span><span>{{ delivery.orderLineId || '&nbsp;' }}</span></div>\n</div>\n<div ng-if=\"delivery.comment\" class=\"description\">\n  <div class=\"label\">{{ t('fleetDelDriverComment') }}</div>\n  <div>{{ delivery.comment }}</div>\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/deliveryStatusTooltip.jade
 ** module id = 22
 ** module chunks = 1
 **/